/* eslint-disable */
// /src/services/settlementsRankingService.js
import {
    collection, getDocs, limit as qlimit, orderBy, query, where
} from "firebase/firestore";
import { db } from "./firebase";



function pickAmount(d) {
    const cand = [
        d?.payload?.totalFare,
        d?.totalFare,
        d?.amountKRW,
        d?.salesKRW,
        d?.["총운임(vat포함)"],
        d?.매출액,
    ].find(v => v !== undefined);
    const n = Number(cand || 0);
    return Number.isFinite(n) ? n : 0;
}

/** 가맹명 */
function pickFranchiseName(d) {
    return (
        d?.payload?.franchiseName ||
        "가맹명 없음"
    );
}


// services/settlementsRankingService.js (해당 함수 부분만 교체)

export async function fetchTopSettlementsByFare(
    topN = 10,
    { onlyWithFourDigits = false, kind = "personal" } = {}
) {
    const col = collection(db, "settlements_raw");

    try {
        // 1) 가장 최근 정산 월 키 조회
        const latestQ = query(
            col,
            where("settlementType", "==", kind),          // 개인 / 법인
            orderBy("settlementMonthKey", "desc"),
            qlimit(1)
        );

        const latestSnap = await getDocs(latestQ);
        if (latestSnap.empty) {
            console.log(
                "[fetchTopSettlementsByFare] no settlements for kind:",
                kind
            );
            return [];
        }

        const latestDoc = latestSnap.docs[0];
        const latestMonthKey =
            latestDoc.data()?.settlementMonthKey || null;

        console.log("[ranking] latestMonthKey =", latestMonthKey);

        if (!latestMonthKey) {
            return [];
        }

        // 2) 해당 월 기준 TOP N 후보 조회
        const q = query(
            col,
            where("settlementType", "==", kind),
            where("settlementMonthKey", "==", latestMonthKey),
            orderBy("payload.totalFare", "desc"),
            qlimit(topN * 5)
        );

        const snap = await getDocs(q);
        console.log(
            "[fetchTopSettlementsByFare] month size =",
            snap.size
        );

        let rows = snap.docs.map((doc) => {
            const d = doc.data() || {};
            const name = pickFranchiseName(d); // payload.franchiseName / carrierName 등에서 뽑는 함수
            const sales = pickAmount(d);
            const region = d?.payload?.region;

            return {
                id: doc.id,
                user: name,
                franchiseName: name,
                sales,
                region,
            };
        });

        console.log("[ranking] rows(before filters) =", rows);

        // 3) 개인 페이지에서만 차량번호 4자리 패턴(선택)
        if (kind === "personal" && onlyWithFourDigits) {
            const before = rows.length;
            rows = rows.filter((r) => /\d{4}$/.test(r.franchiseName || ""));
            console.log(
                "[ranking] fourDigits filter:",
                before,
                "->",
                rows.length
            );
        }

        const finalRows = rows
            .filter((r) => typeof r.sales === "number" && r.sales > 0)
            .sort((a, b) => b.sales - a.sales)
            .slice(0, topN);

        console.log("[ranking] finalRows =", finalRows);

        // ✅ 배열에 latestMonthKey 메타 정보 태워서 반환 (기존 호출부와 호환)
        finalRows.latestMonthKey = latestMonthKey;

        return finalRows;
    } catch (e) {
        console.error("[fetchTopSettlementsByFare] error =", e);

        // 개발 환경에서는 그대로 터뜨려서 인덱스 링크 보이게
        if (process.env.NODE_ENV !== "production") {
            throw e;
        }

        // 운영에서는 조용히 처리
        console.warn(
            "[fetchTopSettlementsByFare] failed (prod):",
            e?.message || e
        );
        return [];
    }
}



/** ✅ 법인 전용 Top N
 *  - 규칙: franchiseName 이 "숫자 4자리로 끝나지 않는" 항목만 (개인 패턴 제외)
 */
// /src/services/settlementsRankingService.js (예상 경로)
// 상단 import에 where, orderBy, limit as qlimit 이 이미 있다면 그대로 사용

// /src/services/settlementsRankingService.js 중 일부

export async function fetchCorporateTopByFare(topN = 5) {
    const col = collection(db, "settlements_raw");

    const buildRows = (snap) => {
        let rows = snap.docs.map((doc) => {
            const d = doc.data() || {};
            const name = pickFranchiseName(d);
            const sales = pickAmount(d);

            return {
                id: doc.id,
                corp: name,
                franchiseName: name,
                sales,
            };
        });

        // 0원/NaN 제거 후 매출 큰 순 정렬
        rows = rows.filter((r) => typeof r.sales === "number" && r.sales > 0);
        return rows.sort((a, b) => b.sales - a.sales).slice(0, topN);
    };

    try {
        // 1) 가장 최근 정산월 키 조회 (법인만)
        const latestQ = query(
            col,
            where("settlementType", "==", "corporate"),
            orderBy("settlementMonthKey", "desc"),
            qlimit(1)
        );

        const latestSnap = await getDocs(latestQ);
        if (latestSnap.empty) {
            console.log("[fetchCorporateTopByFare] no corporate settlements");
            return [];
        }

        const latestMonthKey =
            latestSnap.docs[0].data()?.settlementMonthKey || null;
        console.log("[fetchCorporateTopByFare] latestMonthKey =", latestMonthKey);

        if (!latestMonthKey) return [];

        // 2) 해당 월 + 법인 기준 TOP N 후보 조회
        const q = query(
            col,
            where("settlementType", "==", "corporate"),
            where("settlementMonthKey", "==", latestMonthKey),
            orderBy("payload.totalFare", "desc"),
            qlimit(topN * 5)
        );

        const snap = await getDocs(q);
        console.log(
            "[fetchCorporateTopByFare] month size =",
            snap.size
        );

        const rows = buildRows(snap);

        // ✅ 배열에 최신 정산월 메타를 같이 태워서 반환
        rows.latestMonthKey = latestMonthKey;

        return rows;
    } catch (e) {
        console.error("[fetchCorporateTopByFare] error =", e);
        // 개발 환경에서는 인덱스 링크 보이게 그대로 터뜨리기
        if (process.env.NODE_ENV !== "production") {
            throw e;
        }
        // 운영에서는 조용히 빈 배열
        return [];
    }
}



/** ✅ 법인: franchiseName에 '숫자가 하나도 없는' 항목만 대상으로 Top N
 *  - 화면에는 매출/금액을 노출하지 않음 (내부 정렬에만 사용)
 */
export async function fetchCorporateTopByFareNoDigits(topN = 5) {
    const col = collection(db, "settlements_raw");
    // 여유분 많이 가져와서 필터 후 상위 컷
    try {
        const q = query(col, orderBy("payload.totalFare", "desc"), qlimit(topN * 20));
        const snap = await getDocs(q);
        let rows = snap.docs.map(doc => {
            const d = doc.data() || {};
            const name = pickFranchiseName(d);
            return { id: doc.id, corp: name, sales: pickAmount(d) };
        });
        // 숫자 하나도 없는 가맹명만
        rows = rows.filter(r => !/\d/.test(r.corp || ""));
        return rows.sort((a, b) => b.sales - a.sales).slice(0, topN);
    } catch (e) {
        console.warn("[corp ranking] payload.totalFare order failed, local fallback.", e?.message || e);
    }
    // fallback: 전체 로컬
    const snap = await getDocs(col);
    let all = snap.docs.map(doc => {
        const d = doc.data() || {};
        const name = pickFranchiseName(d);
        return { id: doc.id, corp: name, sales: pickAmount(d) };
    });
    all = all.filter(r => !/\d/.test(r.corp || ""));
    return all.sort((a, b) => b.sales - a.sales).slice(0, topN);
}
